export class BookingCalculate {
    constructor() {
        const total = parseFloat(document.querySelector('#total').value);
        const required = parseFloat(document.querySelector('#required').value);
        const notRequired = parseFloat(document.querySelector('#notRequired').value);
        const balance = parseFloat(document.querySelector('#balance').value);
        const benefitsMax = parseFloat(document.querySelector('#benefitsMax').value);
        const isPingPong = parseInt(document.querySelector('#isPingPong').value);
        const pingPongList = document.querySelectorAll('#bookingSummary .rez_wybrane_re_li');
        const isNotAvailable = parseInt(document.querySelector('#isNotAvailable').value);


        let select = parseInt($('#paymentSelect').val());
        if (isNaN(select)) {
            select = 2;
        } else {
            select = 1;
        }

        const pricesPingPong = [];

        pingPongList.forEach((element) => {
            const {price} = element.dataset;
            pricesPingPong.push(parseFloat(price.replace(',', '.')));
        });

        const pingPongPrices = pricesPingPong.sort((a, b) => {
            return b - a;
        });

        const inputBenefits = document.querySelector('#benefits');

        this.data = {
            benefit: {
                count: 0,
                price: 15,
                total: 0,
                maxCount: benefitsMax,
                pingPongList: pingPongPrices,
            },
            paymentSelect: select,
            total: total,
            required: required,
            notRequired: notRequired,
            balance: balance,
        };

        if (!isNotAvailable) {
            return;
        }

        $("#benefits").bind('keyup keydown blur', (event) => {
            let value = parseInt(event.target.value);
            if (isNaN(value)) {
                value = '';
            }

            if (value > this.data.benefit.maxCount) {
                value = this.data.benefit.maxCount;
            }

            $("#benefits").val(value);
        });

        const paymentSelect = document.querySelector('#paymentSelect');

        if (balance === 0 || balance < 0) {

            $('#benefitsForm').click(() => {
                this.data.benefit.count = 0;
                $("#benefits").val('');

                if (this.data.paymentSelect === 2) {
                    this.data.required = total;
                    this.data.notRequired = 0;
                    this.render();
                } else {
                    this.data.required = required;
                    this.data.notRequired = notRequired;
                    this.render();
                }
            });


            $('#paymentSelect').change(() => {
                this.data.paymentSelect = parseInt(paymentSelect.value);

                if (this.data.paymentSelect === 2) {
                    this.data.required = total;
                    this.data.notRequired = 0;
                    this.fullPayment(isPingPong);
                } else {
                    this.data.required = required;
                    this.data.notRequired = notRequired;
                    this.requiredPayment(isPingPong);
                }

                this.render();
            }).trigger('change');

            $("#benefits").bind('keyup keydown', () => {
                this.data.benefit.count = this._getValueFromInput(inputBenefits.value);
                this.data.benefit.total = this.data.benefit.count * this.data.benefit.price;

                if (this.data.paymentSelect === 2) {
                    if (isPingPong) {
                        this.data.required = this.data.total - this._getTotalBenefitsPingPong();
                    } else {
                        this.data.required = this.data.total - this.data.benefit.total;
                    }

                    if (this.data.required <= 0) {
                        this.data.required = 0;
                    }

                } else {
                    this.data.required = required;
                    this.data.notRequired = notRequired;
                    this.requiredPayment(isPingPong);
                }
                this.render();
            });

        } else {
            $('#benefitsForm').click(() => {
                this.data.benefit.count = 0;
                $("#benefits").val('');

                if (this.data.paymentSelect === 2) {
                    this.data.required = total - balance;
                    this.data.balance = 0;
                    if (this.data.required <= 0) {
                        this.data.balance = this.data.required * -1;
                        this.data.required = 0;
                    }
                    this.data.notRequired = 0;
                    this.render();
                } else {
                    this.data.required = required - balance;
                    this.data.notRequired = notRequired;
                    if (this.data.required <= 0) {
                        this.data.required = 0;
                    }
                    this.render();
                }
            }).trigger('click').trigger('click');

            $('#paymentSelect').change(() => {
                this.data.paymentSelect = parseInt(paymentSelect.value);

                if (this.data.paymentSelect === 2) {
                    this.data.required = total - balance;
                    this.data.balance = 0;
                    if (this.data.required <= 0) {
                        this.data.balance = this.data.required * -1;
                        this.data.required = 0;
                    }
                    this.data.notRequired = 0;
                } else {
                    this.data.required = required;
                    this.data.notRequired = notRequired;
                    this.data.balance = balance - required;
                    if (this.data.balance < 0) {
                        this.data.balance = 0;
                    }

                    this.data.required = required - balance;
                    if (this.data.required <= 0) {
                        this.data.required = 0;
                    }
                }
                this.requiredPayment(isPingPong, this.data.paymentSelect);

                this.render();
            }).trigger('change');

            $("#benefits").bind('keyup keydown', () => {
                this.data.benefit.count = this._getValueFromInput(inputBenefits.value);
                this.data.benefit.total = this.data.benefit.count * this.data.benefit.price;

                if (this.data.paymentSelect === 2) {
                    if (isPingPong) {
                        this.data.required = this.data.total - balance - this._getTotalBenefitsPingPong();
                    } else {
                        this.data.required = this.data.total - balance - this.data.benefit.total;
                    }
                    if (this.data.required < 0) {
                        this.data.required = 0;
                    }
                } else {
                    this.data.required = required;
                    this.data.notRequired = notRequired;

                    if (this.data.required) {
                        this.data.required = required - balance;
                        if (this.data.required < 0) {
                            this.data.required = 0;
                        }
                    } else {
                        this.data.notRequired = notRequired;
                    }
                    this.requiredPayment(isPingPong);
                }

                this.render();
            });
        }

        this.render();
    }

    render() {
        const total = document.querySelector('#vTotal');
        const required = document.querySelector('#vRequired');
        const notRequired = document.querySelector('#vNotRequired');
        const balance = document.querySelector('#vBalance');

        required.textContent = this.data.required.toFixed(2);
        notRequired.textContent = this.data.notRequired.toFixed(2);
        balance.textContent = this.data.balance.toFixed(2);
    }

    requiredPayment(isPingPong = false, paymentSelect = 1) {
        this.data.benefit.total = this.data.benefit.count * this.data.benefit.price;

        if (this.data.required <= 0) {
            if (isPingPong) {
                this.data.notRequired = this.data.notRequired - this._getTotalBenefitsPingPong();
            } else {
                this.data.notRequired = this.data.notRequired - this.data.benefit.total;
            }

            if (this.data.notRequired <= 0) {
                this.data.notRequired = 0;
            }
        }

        if (this.data.required) {
            if (isPingPong) {
                this.data.required = this.data.required - this._getTotalBenefitsPingPong();
            } else {
                this.data.required -= this.data.benefit.total;
            }

            if (this.data.required <= 0) {
                this.data.notRequired -= this.data.required * -1;
                this.data.required = 0;
                if (this.data.notRequired < 0) {
                    this.data.notRequired = 0;
                }
            }
        }
    }

    _benefits() {

    }

    fullPayment(isPingPong = false) {
        if (isPingPong) {
            this.data.required -= this._getTotalBenefitsPingPong();
        } else {
            this.data.required -= this.data.benefit.total;
        }
        if (this.data.required <= 0) {
            this.data.required = 0;
        }
    }

    _getValueFromInput(value) {
        let isValue = parseInt(value);
        if (isNaN(isValue)) {
            return 0;
        } else {
            return value;
        }
    }

    _getTotalBenefitsPingPong() {
        let countBenefit = this.data.benefit.count - 1;
        let totalPrice = 0;

        for (let i = 0; i <= countBenefit; i++) {
            totalPrice += this.data.benefit.pingPongList[i];
        }

        return totalPrice;
    }
}
